module.exports = __webpack_public_path__ + "static/media/logo_morningstar.2fcf70fb.svg";